import NZ from "./newZealand.json";
import AU from "./australia.json";
import UK from "./unitedKingdom.json";
const countriesData = {
  NZ,
  AU,
  GB: UK,
};

export default countriesData;
